export default [
    {
        _name: "CSidebarNav",
        _children: [{
            _name: "CSidebarNavItem",
            name: "Dashboard",
            to: "/dashboard",
            icon: "cil-speedometer",
            badge: {
                color: "primary",
                text: "NEW"
            }
        },
            {
                _name: "CSidebarNavTitle",
                _children: ["Feature"]
            },
            {
                _name: "CSidebarNavItem",
                name: "Event & Tips",
                to: "/management/corporate",
                icon: 'cil-file',
            },
            {
                _name: "CSidebarNavItem",
                name: "Shortlink",
                to: "/management/shortlink",
                icon: "cil-link"
            },
        ]
    }
]

